import React, { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useParams } from "react-router";

const PortfolioDetails = () => {
  const { portfolioId } = useParams();
  const [project, setProject] = useState([]);
  useEffect(() => {
    fetch(`https://shielded-spire-57395.herokuapp.com/projects/${portfolioId}`)
      .then((res) => res.json())
      .then((data) => setProject(data));
  }, []);
  console.log(project);
  return (
    <div>
      <Container className="mt-5 my-5">
        <Row xs={1} md={2}>
          <Col>
            <div className="detail-img">
              <img width="450px" src={project.long_img} alt="" />{" "}
            </div>
          </Col>
          <Col>
            <div className="portfolio-detail-txt">
              <h2>About this projects:</h2>
              <hr />
              <h3>{project.name}</h3>
              <p>A {project.type}</p>
              <p>{project.details}</p>
              <h3>All links of this projects:</h3>
              <a target="_blank" href={project.live_site_link}>
                <button className="primary-btn">Live Demo</button>
              </a>
              <br />
              <br />
              <a target="_blank" href={project.frontend_github}>
                <button className="primary-btn">Client Site Link</button>
              </a>
              <a target="_blank" href={project.backend_github}>
                <button className="primary-btn">Server site link</button>
              </a>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default PortfolioDetails;
